import { Fragment, h } from '@stencil/core';
import { Term } from '../../../redux/types';
import { t } from '../../../redux/utils';
import { termKey } from '../../../utils/trans';
import CheckboxField from '../../stencil-form/CheckboxField';

export enum PaymentStepState {
  SelectPayment = 'selectPayment',
  ProvideMethod = 'provideMethod',
  AcceptTerms = 'acceptTerms',
  Ready = 'ready',
}

export function renderTerm(term: Term, company: string, currentMethod: string, props, termRef?, termsStyle?: boolean) {
  const text = t(termKey(term.id), { companyName: company }).replace(/href/g, "target='_blank' href");

  if (term.type === 'checkbox') {
    if (term.id === 'sepa' && currentMethod !== 'stripe-sepa') {
      return null;
    }

    return (
      <Fragment>
        <CheckboxField labelRef={el => termRef?.(el)} {...props} termsStyle={termsStyle} name={term.id} labelHtml={text} validate={{ required: true }} />
        <rentware-spacer size="S" />
      </Fragment>
    );
  }

  if (term.type === 'text') {
    return (
      <Fragment>
        <span innerHTML={text} />
        <rentware-spacer size="S" />
      </Fragment>
    );
  }
}
